import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
    banner: {
        width: '100%',
        marginBottom: theme.spacing(4),
        borderRadius: 0,
    },
}));
